import React from "react";

const AnchorLink = ({ className = undefined, label="", href="#" }) => (
    <a href={href} className={className} target="_blank" rel="noreferrer">{label}</a>
);

export default AnchorLink;
